import PropTypes from 'prop-types'
import React from 'react'

import Carousel from './Carousel'
import Link from './Link'

const PressSliderItem = ({ content, image, source }) => {
  const Component = source ? Link : 'div'
  const extraProps = source ? { href: source, target: '_blank' } : undefined
  return (
    <Component
      {...extraProps}
      className='press-carousel__item mx-auto col-10 md-col-6 h350 flex flex-column justify-center'
    >
      <div
        className='text-para light mb2'
        dangerouslySetInnerHTML={{ __html: content }}
      />
      <img
        className='press-carousel__item__img block mx-auto'
        width='200'
        src={image}
        alt=''
      />
    </Component>
  )
}

const PressCarousel = ({ slides }) => (
  <Carousel
    extraClass='press-carousel'
    slides={slides}
    slideRenderFn={data => PressSliderItem(data)}
  />
)

PressCarousel.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.node.isRequired,
      image: PropTypes.string.isRequired,
      source: PropTypes.string // url
    }).isRequired
  ).isRequired
}

export default PressCarousel



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/PressCarousel.js